import styled from "styled-components";
import Img from "gatsby-image";
export const ClientContainer = styled.div`
  width: 100%;
  height: 100%;
  z-index: 100;
`;
export const ClientBg = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin: 2rem;
  grid-gap: 10px;

  @media screen and (max-width: 786px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;
export const ClientImageDiv = styled.div`
  padding: 10px;
  margin-left: 5px;
  display: flex;
  justify-content: center;
  border-radius: 3px;
  height: 100%;
`;
export const ClientImage = styled(Img)`
  border-radius: 3px;
  height: 100%;
  filter: brightness(40%);
  transition: 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
  &:hover {
    filter: brightness(60%);
  }
`;
export const ClientTitle = styled.div`
  padding: 2rem;
  margin-top: 0.5rem;
  display: flex;
  text-align: center;
  font-size: 24px;
  color: #100101;
`;
export const TextWrap = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 105px;
`;
export const ClientInfo = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  padding: 0 2 rem;
  @media screen and (max-width: 280px) {
    padding: 0 1rem;
    margin-left: 0.1rem;
  }
  margin-left: 2rem;
`;
export const ClientCard = styled.div`
  line-height: 2;
  /* width: 100%;
  height: 100%; */
  position: relative;
  border-radius: 5px;
  transition: 0.2 ease;
`;
export const ClientImageCard = styled.div`
  /* max-height: 400px; */
  /* max-width: 400px; */
  height: 360px;
  filter: brightness(70%);
  margin-right: 0px;
  display: block;
  justify-content: flex-end;
`;
export const DemoTitle = styled.p`
  font-weight: 400;
  font-size: 1rem;
  margin-left: 0.5rem;
  color: white;
`;
